import { Clock, RotateCcw, Sprout } from "lucide-react";
import type { DueReview, FocusSession, GardenStats, SourceNode } from "../types";
import { FocusHistoryPanel } from "./FocusHistoryPanel";
import { GardenStatsPanel } from "./GardenStatsPanel";
import { ReviewPanel } from "./ReviewPanel";

export type GrowTab = "review" | "garden" | "focus";

export const GROW_TABS: Array<{ value: GrowTab; label: string; icon: typeof Clock }> = [
  { value: "garden", label: "Khu vườn", icon: Sprout },
  { value: "focus", label: "Tập trung", icon: Clock },
  // Ôn tập chưa hoàn thiện — để cuối.
  { value: "review", label: "Ôn tập", icon: RotateCcw }
];

type Props = {
  tab: GrowTab;
  sources: SourceNode[];
  reviews: DueReview[];
  reviewsLoading?: boolean;
  onReviewed: (objectId: string) => Promise<void>;
  gardenStats: GardenStats | null;
  gardenLoading?: boolean;
  focusSessions: FocusSession[];
  focusLoading?: boolean;
  focusError?: string;
};

// Body only — the tab menu lives in the left rail (driven by Home), for a 2-column layout.
export function GrowPanel({ tab, sources, reviews, reviewsLoading, onReviewed, gardenStats, gardenLoading, focusSessions, focusLoading, focusError }: Props) {
  return (
    <div>
      {tab === "review" ? <ReviewPanel reviews={reviews} sources={sources} loading={reviewsLoading} onReviewed={onReviewed} /> : null}
      {tab === "garden" ? <GardenStatsPanel stats={gardenStats} loading={gardenLoading} /> : null}
      {tab === "focus" ? <FocusHistoryPanel sessions={focusSessions} loading={focusLoading} error={focusError} /> : null}
    </div>
  );
}
